import http from './http'

class Step {
  fetch () {
    return http.get('/steps')
  }

  save (payload) {
    return http.put('/steps', { assignor: payload })
  }

  sendDoc () {
    return http.post('/steps/send_documentations')
  }
}

export default new Step()



// WEBPACK FOOTER //
// ./src/services/step.js